import React, { useEffect, useState } from "react";
import "./Header.css";
import { Steps } from "intro.js-react";
import "intro.js/introjs.css";
import MyFeedTour from "./MyFeedTour";
import LibraryTour from "./LibraryTour";
import CalenderTour from "./CalenderTour";
import HWTour from "./HWTour";
import PRTour from "./PRTour";
import ActivityTour from "./ActivityTour";
import SummaryTour from "./SummaryTour";
import { engagementHomeSteps } from "../../utils/engagementSteps";
import CommunityTour from "./CommunityTour";
import QueryTour from "./QueryTour";
import { queryHomeSteps } from "../../utils/querySteps";
import { IP } from "../../internalServer";
import { useLocation, useNavigate } from "react-router-dom";
import { queryDetailsSteps } from "../../utils/queryDetails.steps";
import TicketsMain from "../../Ticket";
import assets from "../../assets/assets";
import { useSelector } from "react-redux";
import AssessmentTour from "./AssessmentTour";
import SelfAssessmentTour from "./SelfAssessmentTour";


export default function Header({ handleProfile, handleTicket, sidebarMenuW }) {
  const navigate = useNavigate();
  const userinfo = useSelector((state) => state.currentUser);
  const tag = localStorage.getItem("ActiveHeader");
  const location = useLocation();
  const [activeHeaderToShow, setActiveHeaderToShow] = useState("Dashboard");


  let studentDetail = JSON.parse(localStorage.getItem("breathForStudent"));

  const Footer = localStorage.getItem("footerActive") || "Home";
  const getActiveMenuHome = () => localStorage.getItem("homeSideMenu");
  const getActiveMenuHw = () => localStorage.getItem("hwSideMenu");
  const getActiveMenuSummary = () => localStorage.getItem("summarySideMenu");
  const getActiveMenuEngage = () => localStorage.getItem("engageSideMenu");

  const activeMenuHome = getActiveMenuHome();
  const activeMenuHw = getActiveMenuHw();
  const activeMenuSummary = getActiveMenuSummary();
  const activeMenuEngage = getActiveMenuEngage();
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [ticketClick, setTicketClick] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  const [steps, setSteps] = useState([]);
  const onExit = () => {
    setStepsEnabled(false);
  };
  console.log("Footer", Footer)
  console.log(ticketClick);
  useEffect(() => {
    switch (Footer) {
      case "Home":
        switch (activeMenuHome) {
          case "Dashboard":
            setActiveHeaderToShow("Dashboard");
            setSteps([
              {
                element: ".FoterDetailContainer",
                intro: `
                  <h3>Parent Features Bottom Pane</h3>
                  <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Home' parent is selected.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".home",
                intro: `
                  <h3>Home</h3>
                  <p>Home has 4 features (as shown in left most pane):
                 </p>
                 <ol>
                    <li>My Feed</li>
                    <li>Library</li>
                    <li>Calendar</li>
                    <li>Attendance</li>
                    <li>Blog</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".featuredLeftPane",
                intro: `
                  <h3>Features Group Left Pane
                  Home has 4 features as shown:</h3>
                  <ol>
                    <li>My Feed</li>
                    <li>Library</li>
                    <li>Calendar</li>
                    <li>Attendance</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".myFeed",
                intro: `
                  <h3>My Feed</h3>
                  <p>Currently 'My feed' feature is selected</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".myFeed2",
                intro: `
                  <h3>Dashboard</h3>
                  <p>Let's navigate through my feed feature</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".calenderHomePage ",
                intro: `
                  <h3>Live Calender</h3>
                  <p>It will keep ypu updated with days and dates</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".noticeBoardTitle  ",
                intro: `
                  <h3>School Notice Board</h3>
                  <p>You wil find all the school notices here. Click on notice item to get its details.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".thoughts  ",
                intro: `
                  <h3>Motivational Thoughts</h3>
                  <p>Thoughts from great leaders to keep you positive and motivated in life.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".todaysHistory",
                intro: `
                  <h3>Today's Importance In History</h3>
                  <p>Get to know today's date importance in history.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".upcomingClasses",
                intro: `
                  <h3>Upcoming Classes</h3>
                  <p>Know your upcoming classes here.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".prifilePic",
                intro: `
                  <h3>Your profile, B4S App layout</h3>
                  <p>Access your profile Information.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".done",
                intro: `
                  <h3>Awesome, you are done. 😊</h3>
                  <p>Click anywhere on the screen or click on the cross icon.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
            ]);
            break;
          case "Library":
            setActiveHeaderToShow("Library");
            setSteps([
              {
                element: ".home",
                intro: `
                  <h3>Home</h3>
                  <p>Home has 4 features (as shown in left most pane):
                 </p>
                 <ol>
                    <li>My Feed</li>
                    <li>Library</li>
                    <li>Calendar</li>
                    <li>Attendance</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".featuredLeftPane",
                intro: `
                  <h3>Features Group Left Pane
                  Home has 4 features as shown:</h3>
                  <ol>
                    <li>My Feed</li>
                    <li>Library</li>
                    <li>Calendar</li>
                    <li>Attendance</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".library",
                intro: `
                  <h3>Library</h3>
                  <p>You are in library, under home parent</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".subjectsList",
                intro: `
                  <h3>Subjects List</h3>
                  <p>You will find curriculum subject lists here. Click on any subject to see its content.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".suggestedMaterials ",
                intro: `
                  <h3>Suggested Study Materials</h3>
                  <p>You will find external suggested study materials here. Click on any material to see details</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".prifilePic",
                intro: `
                  <h3>Your profile, B4S App layout</h3>
                  <p>Access your profile Information.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".done",
                intro: `
                  <h3>Awesome, you are done. 😊</h3>
                  <p>Click anywhere on the screen or click on the cross icon.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
            ]);
            break;
          case "Calender":
            setActiveHeaderToShow("Calender");
            setSteps([
              {
                element: ".home",
                intro: `
                    <h3>Home</h3>
                    <p>Home has 4 features (as shown in left most pane):
                   </p>
                   <ol>
                      <li>My Feed</li>
                      <li>Library</li>
                      <li>Calendar</li>
                      <li>Attendance</li>
                    </ol>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".featuredLeftPane",
                intro: `
                    <h3>Features Group Left Pane
                    Home has 4 features as shown:</h3>
                    <ol>
                      <li>My Feed</li>
                      <li>Library</li>
                      <li>Calendar</li>
                      <li>Attendance</li>
                    </ol>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".calender",
                intro: `
                    <h3>Calender</h3>
                    <p>Currently 'Calender' feature is selected</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".weeklyDatesPane",
                intro: `
                    <h3>Weekly Dates Pane</h3>
                    <p>You will find 7 Dates for the Week Count shown above to it.
                    You can Click over any Date to See Timetable for that Date.</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".selDate",
                intro: `
                    <h3>Selected Date</h3>
                    <p>
                    It shows the Selected Date and Day in Weekly Dates Pane'. Timetable is displayed below for this Date.</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".weekPans",
                intro: `
                    <h3>Week Pane</h3>
                    <p>
                    It shows the Week Number, Month and Yeat
        You can move to different Weeks here and Select Date in Weekly Dates Pane' below to fetch Timeta
        selected Date</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".dailyTTPane",
                intro: `
                    <h3>Daily Time Table Pane</h3>
                    <p>
                    It shows daily timetable (Lectures and your study planners)</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".e-toolbar-right",
                intro: `
                    <h3>Daily/Weekly Time Table session</h3>
                    <p>
                    You can select daily or weekly time table form here</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".studyPlanner",
                intro: `
                    <h3>Create Study Planner</h3>
                    <p>
                    You can create study planner form here</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".lectureStudyPlanner",
                intro: `
                    <h3>Lecture and Study Planner Section</h3>
                    <p>
                    If you wish you can select to see only lectures or only study planners from here</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".holidaysList",
                intro: `
                    <h3>Holidays List</h3>
                    <p>
                    You can find holidays list here</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".prifilePic",
                intro: `
                    <h3>Your profile, B4S App layout</h3>
                    <p>Access your profile Information.</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".done",
                intro: `
                    <h3>Awesome, you are done. 😊</h3>
                    <p>Click anywhere on the screen or click on the cross icon.</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
            ]);
            break;
          case "StudentAttendance":
            setActiveHeaderToShow("StudentAttendance");
            setSteps([
              {
                element: ".home",
                intro: `
                    <h3>Home</h3>
                    <p>Home has 4 features (as shown in left most pane):
                   </p>
                   <ol>
                      <li>My Feed</li>
                      <li>Library</li>
                      <li>Calendar</li>
                      <li>Attendance</li>
                    </ol>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".featuredLeftPane",
                intro: `
                    <h3>Features Group Left Pane
                    Home has 4 features as shown:</h3>
                    <ol>
                      <li>My Feed</li>
                      <li>Library</li>
                      <li>Calendar</li>
                      <li>Attendance</li>
                    </ol>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".attendance",
                intro: `
                    <h3>Library</h3>
                    <p>You are in attendance, under home parent</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".TakeAttendance",
                intro: `
                    <h3>Take Attendance</h3>
                    <p>You can take your attendance. Click on any takeattendnce.</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".ViewReport ",
                intro: `
                    <h3>Your View Report</h3>
                    <p>You can see your daily attendance report. Click on viewreport to see details</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".prifilePic",
                intro: `
                    <h3>Your profile, B4S App layout</h3>
                    <p>Access your profile Information.</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".done",
                intro: `
                    <h3>Awesome, you are done. 😊</h3>
                    <p>Click anywhere on the screen or click on the cross icon.</p>
                  `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
            ]);
            break;
          default:
            setActiveHeaderToShow("My Feed");
            break;
        }
        break;
      case "HMW":
        switch (activeMenuHw) {
          case "Homework":
            setActiveHeaderToShow("Homework");
            setSteps([
              {
                element: ".FoterDetailContainer",
                intro: `
                  <h3>Parent Features Bottom Pane</h3>
                  <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Home' parent is selected.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".homeWork",
                intro: `
                  <h3>Smart.Homework</h3>
                  <p>Smart.Homework has 4 features (as shown in left most pane):
                 </p>
                 <ol>
                    <li>Homework</li>
                    <li>Pre-Read</li>
                    <li>Activity</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".featuredLeftPaneHWM",
                intro: `
                  <h3>Features Group Left Pane
                  Smart.Homework has 3 features as shown:</h3>
                  <ol>
                  <li>Homework</li>
                  <li>Pre-Read</li>
                  <li>Activity</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".hw",
                intro: `
                  <h3>Dashboard</h3>
                  <p>Currently 'Homework' feature is selected, Let's navigate through this feature</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".subWiseHW ",
                intro: `
                  <h3>Subject Wise Home Work</h3>
                  <p>You can see subject wise homework count for 'pending', 'review' and 'completed'</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".CardsHW",
                intro: `
                  <h3>Cards Section</h3>
                  <p>You can open homework from this section.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".pendingHW",
                intro: `
                  <h3>Pending</h3>
                  <p>In this tab you will find Homeworks which needs to be submitted by you.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".reviewHW",
                intro: `
                  <h3>On Review</h3>
                  <p>You will find your submitted homeworks which are yet to be reviewed by teacher.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".completedHW",
                intro: `
                  <h3>Completed</h3>
                  <p>You will find your submitted homeworkds which are reviewed by teacher.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".filterHW",
                intro: `
                  <h3>Filter</h3>
                  <p>Using filter button you can filter items by subject time and date wise.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".sortByHW",
                intro: `
                  <h3>Sort By</h3>
                  <p>Using Sort by Button you can sort items in ascending or descending based on date.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".prifilePic",
                intro: `
                  <h3>Your profile, B4S App layout</h3>
                  <p>Access your profile Information.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".done",
                intro: `
                  <h3>Awesome, you are done. 😊</h3>
                  <p>Click anywhere on the screen or click on the cross icon.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
            ]);
            break;
          case "Pre-read":
            setActiveHeaderToShow("Pre-read");
            setSteps([
              {
                element: ".FoterDetailContainer",
                intro: `
                  <h3>Parent Features Bottom Pane</h3>
                  <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Homework' parent is selected.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".homeWork",
                intro: `
                  <h3>Smart.Homework</h3>
                  <p>Smart.Homework has 4 features (as shown in left most pane):
                 </p>
                 <ol>
                    <li>Homework</li>
                    <li>Pre-Read</li>
                    <li>Activity</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".featuredLeftPaneHWM",
                intro: `
                  <h3>Features Group Left Pane
                  Smart.Homework has 3 features as shown:</h3>
                  <ol>
                  <li>Homework</li>
                  <li>Pre-Read</li>
                  <li>Activity</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".pr",
                intro: `
                  <h3>Pre-Read</h3>
                  <p>Currently 'Pre-Read' feature is selected, Let's navigate through this feature</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".subWisePR ",
                intro: `
                  <h3>Subject Wise Pre Read</h3>
                  <p>You can see subject wise pre read count for 'pending' and 'completed'</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".CardsPR  ",
                intro: `
                  <h3>Cards Section</h3>
                  <p>You can open pre reads from this section.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".pendingPR",
                intro: `
                  <h3>Pending</h3>
                  <p>In this tab you will find Pre reads which needs to be submitted by you.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".completedPR",
                intro: `
                  <h3>Completed</h3>
                  <p>You will find your submitted homeworkds which are reviewed by teacher.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".filterPR",
                intro: `
                  <h3>Filter</h3>
                  <p>Using filter button you can filter items by subject time and date wise.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".sortByPR",
                intro: `
                  <h3>Sort By</h3>
                  <p>Using Sort by Button you can sort items in ascending or descending based on date.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".prifilePic",
                intro: `
                  <h3>Your profile, B4S App layout</h3>
                  <p>Access your profile Information.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".done",
                intro: `
                  <h3>Awesome, you are done. 😊</h3>
                  <p>Click anywhere on the screen or click on the cross icon.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
            ]);
            break;
          case "Activity":
            setActiveHeaderToShow("Activity");
            setSteps([
              {
                element: ".FoterDetailContainer",
                intro: `
                  <h3>Parent Features Bottom Pane</h3>
                  <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Homework' parent is selected.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".homeWork",
                intro: `
                  <h3>Smart.Homework</h3>
                  <p>Smart.Homework has 4 features (as shown in left most pane):
                 </p>
                 <ol>
                    <li>Homework</li>
                    <li>Pre-Read</li>
                    <li>Activity</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".featuredLeftPaneHWM",
                intro: `
                  <h3>Features Group Left Pane
                  Smart.Homework has 3 features as shown:</h3>
                  <ol>
                  <li>Homework</li>
                  <li>Pre-Read</li>
                  <li>Activity</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".activity",
                intro: `
                  <h3>Activity</h3>
                  <p>Currently 'Pre-Read' feature is selected, Let's navigate through this feature</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".subWiseA ",
                intro: `
                  <h3>Subject Wise Activity</h3>
                  <p>You can see subject wise Activity count for 'pending', 'review' and 'completed'</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".CardsA  ",
                intro: `
                  <h3>Cards Section</h3>
                  <p>You can open Activities from this section.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".pendingA",
                intro: `
                  <h3>Pending</h3>
                  <p>In this tab you will find Activities which needs to be submitted by you.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".reviewA",
                intro: `
                  <h3>On Review</h3>
                  <p>You will find your submitted Activities which are yet to be reviewed by teacher.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".completedA",
                intro: `
                  <h3>Completed</h3>
                  <p>You will find your submitted Ativities which are reviewed by teacher.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".filterA",
                intro: `
                  <h3>Filter</h3>
                  <p>Using filter button you can filter items by subject time and date wise.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".sortByA",
                intro: `
                  <h3>Sort By</h3>
                  <p>Using Sort by Button you can sort items in ascending or descending based on date.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".prifilePic",
                intro: `
                  <h3>Your profile, B4S App layout</h3>
                  <p>Access your profile Information.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".done",
                intro: `
                  <h3>Awesome, you are done. 😊</h3>
                  <p>Click anywhere on the screen or click on the cross icon.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
            ]);
            break;
          default:
            setActiveHeaderToShow("Homework");
            break;
        }
        break;
      case "DCM":
        switch (activeMenuSummary) {
          case "Summary":
            setActiveHeaderToShow("Summary");
            setSteps([
              {
                element: ".FoterDetailContainer",
                intro: `
                  <h3>Parent Features Bottom Pane</h3>
                  <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Digital.Class' parent is selected.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".digitalClass",
                intro: `
                  <h3>Digital.Class</h3>
                  <p>Digital.Class has 2 features (as shown in left most pane):
                 </p>
                 <ol>
                    <li>Summary</li>
                    <li>Assessment</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".featuredLeftPaneDC",
                intro: `
                  <h3>Features Group Left Pane
                  Digital.Class has 3 features as shown:</h3>
                  <ol>
                  <li>Summary</li>
                  <li>Assessment</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".summary",
                intro: `
                  <h3>Summary</h3>
                  <p>Currently 'Summary' feature is selected, Let's navigate through this feature</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".summaryItems",
                intro: `
                  <h3>Summary Items</h3>
                  <p>These are summary items which you can scroll vertically.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".filterSummary",
                intro: `
                  <h3>Filter</h3>
                  <p>Using filter button you can filter items by subject, time and date time.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".prifilePic",
                intro: `
                  <h3>Your profile, B4S App layout</h3>
                  <p>Access your profile Information.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".done",
                intro: `
                  <h3>Awesome, you are done. 😊</h3>
                  <p>Click anywhere on the screen or click on the cross icon.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
            ]);
            break;
          case "LIVE":
            setActiveHeaderToShow("Digital Class management");
            break;
          case "Assessment":
            setActiveHeaderToShow("Assessment");
            setSteps([
              {
                element: ".FoterDetailContainer",
                intro: `
                  <h3>Parent Features Bottom Pane</h3>
                  <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Homework' parent is selected.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".digitalClass",
                intro: `
                  <h3>Digital.Class</h3>
                  <p>Digital.Class has 2 features (as shown in left most pane):
                 </p>
                 <ol>
                    <li>Summary</li>
                    <li>Assessment</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".featuredLeftPaneDC",
                intro: `
                  <h3>Features Group Left Pane
                  Digital.Class has 3 features as shown:</h3>
                  <ol>
                  <li>Summary</li>
                  <li>Assessment</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".assessment",
                intro: `
                  <h3>Assessment</h3>
                  <p>Currently 'Assessment' feature is selected, Let's navigate through this feature</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".CardsAssessment  ",
                intro: `
                  <h3>Today and Other Assessments</h3>
                  <p>You can see assessmments under today and other section.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".pendingAssessment",
                intro: `
                  <h3>Upcoming</h3>
                  <p>In this tab you will find Assessments which needs to be submitted by you.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".reviewAssessments",
                intro: `
                  <h3>On Review</h3>
                  <p>You will find your submitted assessments which are yet to be reviewed by teacher.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".completedAssessment",
                intro: `
                  <h3>Completed</h3>
                  <p>You will find your submitted assessments which are reviewed by teacher.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".filterAssessment",
                intro: `
                  <h3>Filter</h3>
                  <p>Using filter button you can filter items by subject time and date wise.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".sortByAssessment",
                intro: `
                  <h3>Sort By</h3>
                  <p>Using Sort by Button you can sort items in ascending or descending based on date.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".prifilePic",
                intro: `
                  <h3>Your profile, B4S App layout</h3>
                  <p>Access your profile Information.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".done",
                intro: `
                  <h3>Awesome, you are done. 😊</h3>
                  <p>Click anywhere on the screen or click on the cross icon.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
            ]);
            break;
          case "SelfAssessment":
            setActiveHeaderToShow("Self Assessment");
            setSteps([
              {
                element: ".FoterDetailContainer",
                intro: `
                  <h3>Parent Features Bottom Pane</h3>
                  <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Digital.Class' parent is selected.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".digitalClass",
                intro: `
                  <h3>Digital.Class</h3>
                  <p>Digital.Class has 3 features (as shown in left most pane):
                 </p>
                 <ol>
                    <li>Summary</li>
                    <li>Assessment</li>
                    <li>Self.Assessment</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".featuredLeftPaneDC",
                intro: `
                  <h3>Features Group Left Pane
                  Digital.Class has 3 features as shown:</h3>
                  <ol>
                  <li>Summary</li>
                  <li>Assessment</li>
                  <li>Self.Assessment</li>
                  </ol>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".selfAssessment",
                intro: `
                  <h3>Self.Assessment</h3>
                  <p>Currently 'Self.Assessment' feature is selected, Let's navigate through this feature</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".CardsAssessment ",
                intro: `
                  <h3>Today and Other Assessments</h3>
                  <p>You can see self.assessmments under today and other section.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".pendingSelfAssessment",
                intro: `
                  <h3>Pending</h3>
                  <p>In this tab you will find Self.Assessments which needs to be submitted by you.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".completedSelfAssessment",
                intro: `
                  <h3>Completed</h3>
                  <p>You will find your submitted self-assessments which are reviewed by teacher.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },

              {
                element: ".filterAssessment",
                intro: `
                  <h3>Filter</h3>
                  <p>Using filter button you can filter items by subject time and date wise.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".sortByAssessment",
                intro: `
                  <h3>Sort By</h3>
                  <p>Using Sort by Button you can sort items in ascending or descending based on date.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".prifilePic",
                intro: `
                  <h3>Your profile, B4S App layout</h3>
                  <p>Access your profile Information.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
              {
                element: ".done",
                intro: `
                  <h3>Awesome, you are done. 😊</h3>
                  <p>Click anywhere on the screen or click on the cross icon.</p>
                `,
                position: "top",
                tooltipClass: "myTooltipClass",
                highlightClass: "myHighlightClass",
              },
            ]);
            break;
          default:
            setActiveHeaderToShow("Digital Class management");
            break;
        }
        break;

      case "Engagement":
        switch (activeMenuEngage) {
          case "Community":
            setActiveHeaderToShow("Community");
            setSteps(engagementHomeSteps);
            break;
          case "Query":
            setActiveHeaderToShow("Query");
            if (location.pathname.includes("groupWiseQuery")) {
              setSteps(queryDetailsSteps);
            } else {
              setSteps(queryHomeSteps);
            }
            break;
          default:
            setActiveHeaderToShow("Community");
            break;
        }
        break;
      default:
        setActiveHeaderToShow("Dashboard");
        break;
    }
  }, [
    Footer,
    activeMenuHome,
    activeMenuHw,
    activeMenuSummary,
    activeMenuEngage,
    sidebarMenuW,
  ]);

  const [showPopup, setShowPopup] = useState(false);

  const handleClick = () => {
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 5000);
  };

  let stepsComponentToRender;

  if (activeHeaderToShow === "My Feed") {
    stepsComponentToRender = (
      <MyFeedTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
        studentDetail={studentDetail}
      />
    );
  } else if (activeHeaderToShow === "Library") {
    stepsComponentToRender = (
      <LibraryTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  } else if (activeHeaderToShow === "Calender") {
    stepsComponentToRender = (
      <CalenderTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  } else if (Footer === "HMW" && activeMenuHw === "Homework") {
    stepsComponentToRender = (
      <HWTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  } else if (Footer === "HMW" && activeMenuHw === "Pre-read") {
    stepsComponentToRender = (
      <PRTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  } else if (Footer === "HMW" && activeMenuHw === "Activity") {
    stepsComponentToRender = (
      <ActivityTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  } else if (activeHeaderToShow === "Assessment") {
    stepsComponentToRender = (
      // <CalenderTour
      //   setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
      //   setStepsEnabled={setStepsEnabled}
      // />
      <AssessmentTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  } else if (activeHeaderToShow === "Digital Class management") {
    stepsComponentToRender = (
      <SummaryTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  } else if (activeHeaderToShow === "Community") {
    stepsComponentToRender = (
      <CommunityTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  } else if (activeHeaderToShow === "Query") {
    stepsComponentToRender = (
      <QueryTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  } else if (Footer === "DCM" && activeHeaderToShow === "Summary") {
    stepsComponentToRender = (
      <SummaryTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  } else if (Footer === "DCM" && activeHeaderToShow === "Self Assessment") {
    stepsComponentToRender = (
      <SelfAssessmentTour
        setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
        setStepsEnabled={setStepsEnabled}
      />
    );
  }

  // if (tag === "Calender") {
  //   return (
  //     <div className="HeaderDetailContainer d-flex justify-content-between p-3">
  //       <div className="HeaderTitle" style={{ cursor: "pointer" }}>
  //         Calendar
  //       </div>
  //       <div className="d-flex gap-4">
  //         <div style={{ cursor: "pointer" }}>
  //           <img src="/StudentImg/notifcationIcon.png" alt="icon"></img>
  //         </div>
  //         <div style={{ cursor: "pointer" }} onClick={handleProfile}>
  //           <img src="/StudentImg/ProfileIcon.png" alt="icon"></img>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // } else if (tag === "Library") {
  //   return (
  //     <div className="HeaderDetailContainer d-flex justify-content-between p-3">
  //       <div className="HeaderTitle" style={{ cursor: "pointer" }}>
  //         Library
  //       </div>
  //       <div className="d-flex gap-4">
  //         <div style={{ cursor: "pointer" }}>
  //           <img src="/StudentImg/notifcationIcon.png" alt="icon"></img>
  //         </div>
  //         <div style={{ cursor: "pointer" }} onClick={handleProfile}>
  //           <img src="/StudentImg/ProfileIcon.png" alt="icon"></img>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }



  return (
    <>
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />
      <div className="HeaderDetailContainer d-flex justify-content-between p-3">
        <div className="HeaderTitle myFeed2" style={{ cursor: "pointer", fontFamily: "Segoe UI", fontWeight: "700", color: "#F77F00" }}>
          {activeHeaderToShow === "Dashboard" && <div className="d-flex align-items-center"><span><img style={{ width: "50px", marginRight: "20px" }} src={assets.Myfeedimage} alt="img" /></span> <span>{activeHeaderToShow}</span></div>}
          {activeHeaderToShow === "Library" && <div className="d-flex align-items-center"><span><img style={{ width: "55px", marginRight: "20px" }} src={assets.LibraryImage} alt="img" /></span> <span>{activeHeaderToShow}</span></div>}
          {activeHeaderToShow === "Calender" && <div className="d-flex align-items-center"><span><img style={{ width: "50px", marginRight: "20px" }} src={assets.Calendarimage} alt="img" /></span> <span>{activeHeaderToShow}</span></div>}
          {activeHeaderToShow === "StudentAttendance" && <div className="d-flex align-items-center"><span><img style={{ width: "50px", marginRight: "20px" }} src={assets.Calendarimage} alt="img" /></span> <span>{'Attendance'}</span></div>}
          {activeHeaderToShow === "Summary" && <div className="d-flex align-items-center"><span><img style={{ width: "50px", marginRight: "20px" }} src={assets.SummaryImg} alt="img" /></span> <span>{"Lecture Summary"}</span></div>}
          {activeHeaderToShow === "Assessment" && <div className="d-flex align-items-center"><span><img style={{ width: "45px", marginRight: "20px" }} src={assets.AssessmentImg} alt="img" /></span> <span>{activeHeaderToShow}</span></div>}
          {activeHeaderToShow === "Self Assessment" && <div className="d-flex align-items-center"><span><img style={{ width: "55px", marginRight: "20px" }} src={assets.SelfAssessmentImg} alt="img" /></span> <span>{activeHeaderToShow}</span></div>}
          {activeHeaderToShow === "Homework" && <div className="d-flex align-items-center"><span><img style={{ width: "50px", marginRight: "20px" }} src={assets.HomeworkImg} alt="img" /></span> <span>{activeHeaderToShow}</span></div>}
          {activeHeaderToShow === "Pre-read" && <div className="d-flex align-items-center"><span><img style={{ width: "50px", marginRight: "20px" }} src={assets.PreReadImg} alt="img" /></span> <span>{activeHeaderToShow}</span></div>}
          {activeHeaderToShow === "Activity" && <div className="d-flex align-items-center"><span><img style={{ width: "60px", marginRight: "15px" }} src={assets.ActivityImg} alt="img" /></span> <span>{activeHeaderToShow}</span></div>}
          {activeHeaderToShow === "Community" && <div className="d-flex align-items-center"><span><img style={{ width: "50px", marginRight: "20px" }} src={assets.CommunityImg} alt="img" /></span> <span>{activeHeaderToShow}</span></div>}
          {activeHeaderToShow === "Query" && <div className="d-flex align-items-center"><span><img style={{ width: "55px", marginRight: "20px" }} src={assets.QueryImg} alt="img" /></span> <span>{activeHeaderToShow}</span></div>}
        </div>
        <div className="schoolDetails d-flex align-items-center justify-content-center" style={{ opacity: "0.6" }}>
          <div className="schoolLogo">
            <img style={{ width: "60px", height: "60px", marginRight: "8px" }} src={studentDetail?.school?.profile_pic ? IP + studentDetail?.school?.profile_pic : "/images/default_school_logo.jpg"} alt="" />
          </div>
          <div className="schoolName" >
            <div style={{ fontSize: "22px", fontWeight: "700" }} className="text-blue-500">{studentDetail?.school?.name}</div>
            <div style={{ fontSize: "15px", fontWeight: "500", fontStyle: "italic", textAlign: "right" }}>Powered by XploreSense™</div>
          </div>
        </div>
        <div className="d-flex gap-4">
          {showPopup && (
            <div className="pop">
              <div className="pop-content">
                <span className="clos" onClick={() => setShowPopup(false)}>
                  &times;
                </span>
                <div className="clos">Coming Soon</div>
              </div>
            </div>
          )}
          <div
            onClick={() => setHomeScreenWalkThroughPopup(true)}
            className="done">
            <img src="/images/user_guide_feature_b4s.png" alt="icon" style={{ width: "30px", height: "35px", cursor: "pointer" }} />
          </div>
          <div onClick={() => {
            console.log("jewe")
            handleTicket()
          }}>
            <img src="/images/TicketImage.jpeg" alt="ticketImage" className="ImageCont" />
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => handleProfile()}
            className="prifilePic"
          >
            <img
              src={
                studentDetail?.profile_picture
                  ? IP + studentDetail?.profile_picture.replace(/^\./, "")
                  : studentDetail?.gender === "M"
                    ? studentDetail?.avatar_profile ? '/images/Boys/' + studentDetail?.avatar_profile + '.webp'
                      : "/images/Student_boy_pic.png"
                    : studentDetail?.gender === "F"
                      ? studentDetail?.avatar_profile ? '/images/Girls/' + studentDetail?.avatar_profile + '.webp'
                        : "/images/Student_girl_pic.png"
                      : "/images/default image.png"
              }
              alt="icon"
              className="prifilePicImg"
              key={studentDetail?.avatar_profile}
              onError={(e) => {
                if (studentDetail?.gender === "M") {
                  e.target.src = studentDetail?.avatar_profile ? '/images/Boys/' + studentDetail?.avatar_profile + '.webp' : "/images/Student_boy_pic.png"
                } else if (studentDetail?.gender === "F") {
                  e.target.src = studentDetail?.avatar_profile ? '/images/Girls/' + studentDetail?.avatar_profile + '.webp' : "/images/Student_girl_pic.png"
                } else {
                  e.target.src = "/images/default image.png"
                }
              }}
            />
          </div>
        </div>
      </div>
      {homeScreenWalkThroughPopup && stepsComponentToRender}
      <hr style={{ margin: "0.6rem 0rem" }} />
    </>
  );
}
